import axios from 'axios'

//查询采购名称集合
export function getPurchasePlanList () {
  return axios.get(`/manage/purchase-plan/queryList`)
}

